import { propOr } from 'ramda';
import { createSelector } from 'reselect';

import { RootState } from '../types';
import { tableNamesLocaleSelector } from './locale';

export const tableSelector = (state: RootState) => state.table;
export const tableIdSelector = createSelector(tableSelector, (table) => table.id!);
export const tableNameSelector = createSelector(tableSelector, (table) => table.title);
export const tableLimitsSelector = createSelector(tableSelector, (table) => table.limits);

/**
 * Show tableName if it's present in `tableNames.tableId_${tableId}`
 * Fallback to `tableNameSelector`
 */
export const localizedTableNameSelector = createSelector(
  tableNameSelector,
  tableIdSelector,
  tableNamesLocaleSelector,
  (tableName, tableId, tableNames) => propOr(tableName, `tableId_${tableId}`)(tableNames) as string,
);

export const dealerNameSelector = createSelector(
  tableSelector,
  (table) => table.dealer_name,
);
